module.exports = __webpack_public_path__ + "static/media/logo-expo-medica.5f5d4299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-expo-medica.jpg
// module id = 128
// module chunks = 0